"use client"

import { useState, useEffect } from "react"
import styled from "styled-components"
import { motion } from "framer-motion"
import axios from "axios"
import { toast } from "react-toastify"
import History from "../components/History"
import { API_BASE } from "../config/api"

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`

const LoadingContainer = styled(motion.div)`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
`

const LoadingSpinner = styled(motion.div)`
  width: 40px;
  height: 40px;
  border: 3px solid rgba(79, 141, 251, 0.3);
  border-radius: 50%;
  border-top-color: var(--accent-blue);
`

const HistoryPage = () => {
  const [historyItems, setHistoryItems] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        const response = await axios.get(`${API_BASE}/history`, {
          withCredentials: true,
        })

        setHistoryItems(response.data)
      } catch (error) {
        console.error("History fetch error:", error)

        if (error.response && error.response.data && error.response.data.detail) {
          toast.error(error.response.data.detail)
        } else {
          toast.error("Failed to fetch history. Please try again.")
        }
      } finally {
        setIsLoading(false)
      }
    }

    fetchHistory()
  }, [])

  const spinnerVariants = {
    animate: {
      rotate: 360,
      transition: {
        loop: Number.POSITIVE_INFINITY,
        ease: "linear",
        duration: 1,
      },
    },
  }

  return (
    <PageContainer>
      {isLoading ? (
        <LoadingContainer>
          <LoadingSpinner variants={spinnerVariants} animate="animate" />
        </LoadingContainer>
      ) : (
        <History historyItems={historyItems} />
      )}
    </PageContainer>
  )
}

export default HistoryPage

